import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GymAddress } from 'src/app/model/gym-address';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'gymfinder-address-info',
  templateUrl: './address-info.component.html',
  styleUrls: ['./address-info.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false,
})
export class AddressInfoComponent {
  @Input()
  address: GymAddress;

  @Input()
  editMode: boolean;

  @Output()
  addressChange = new EventEmitter<GymAddress>();
}
